import { useEffect, useState } from "react";
import { Button, Card } from "react-bootstrap";
import { SlPencil } from "react-icons/sl";

import { useTheme } from "../context/ThemeContext";

export default function About({ show, hide }) {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <>
      <h2>About</h2>
      <Card className="mb-3">
        <Card.Header className="d-flex align-items-center justify-content-between bg-transparent border-bottom-0">
          <h3 className="mb-0">Bio</h3>
          <Button
            variant="outline-secondary"
            className="edit-btn"
            onClick={() => hide(true)}
          >
            <SlPencil />
          </Button>
        </Card.Header>
        <Card.Body>
          <p className="mb-0">
            Jennifer Adams is a dedicated health practitioner with over a decade
            of experience in preventive care and patient wellness. She
            specializes in guiding individuals toward healthier lifestyle
            choices through evidence-based nutrition, stress management
            techniques, and personalized fitness plans. Known for her
            approachable style and practical advice, Jennifer focuses on
            empowering patients to take small, consistent steps that lead to
            lasting improvements in overall health. Her passion lies in making
            medical knowledge accessible and actionable for everyday life.
          </p>
        </Card.Body>
      </Card>
      <Card>
        <Card.Header className="bg-transparent border-bottom-0">
          <h3 className="mb-0">Theme Settings</h3>
        </Card.Header>
        <Card.Body>
          <div class="form-check form-switch theme-form-switch">
            <label class="form-check-label">Light mode</label>
            <input
              class="form-check-input"
              type="checkbox"
              checked={isDarkMode}
              onChange={toggleTheme}
            />
            <label class="form-check-label">Dark mode</label>
          </div>
        </Card.Body>
      </Card>
    </>
  );
}
